import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _UBLAdminFee } from '../../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectorUBLAdminFeeTypeConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_UBLAdminFee);
    const [id, setID] = useState<number>(idSelector);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
        }
    }, [idSelector]);

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    };

    const getLista = () => {
        instance.getUBLAdminFeeTypeConstants(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        ).catch(err => { toast.error(err) });
    };

    return (
        <>
            <label>{label ?? "Tipo de Distribución"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null
                setValue(valor)
            }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => (
                        <option key={index} value={item.DataBeanProperties.Value}>
                            {item.DataBeanProperties.Property}
                        </option>
                    ))
                }
            </select>
        </>
    );
};
